// import { Notifier } from '@airbrake/browser';
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: '' };
    // this.airbrake = new Notifier({
    //   projectId: 436195,
    //   projectKey: '61957d1008d6466ee212d14d86176689',
    // });
  }

  componentDidCatch(error, info) {
    if (
      this.props.suppressError &&
      error.name.includes(this.props.suppressError)
    ) {
      //  suppress error
      console.warn('Error suppressed: ' + error);
    } else {
      // Display fallback UI
      this.setState({
        hasError: true,
        error: `${error.name}: ${error.message}`,
      });
    }

    // Send error to Airbrake
    // this.airbrake.notify({
    //   error: error,
    //   params: {info: info}
    // });
  }

  render() {
    if (this.state.hasError) {
      const { error } = this.state;
      // You can render any custom fallback UI
      return (
        <>
          <h6>Something went wrong.</h6>
          <div>{error}</div>
        </>
      );
    }
    return this.props.children;
  }
}

export { ErrorBoundary };
